import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const reformDAO: ProjectContentData = {
  id: 'reform-dao',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      layout: 5,
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'eth-and-bsc',
          value: 'ETH',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: '$rfrm',
          value: '$RFRM',
          name: 'Token Ticker',
          description: <span>Symbol of Token.</span>,
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: '34,850,000',
          name: 'Initial Circulating Supply',
          description: <span>Shows the circulating supply at TGE</span>,
        },
        {
          id: 'initial-market-cap',
          value: '$3,485,000',
          name: 'Initial Market Cap',
          description: (
            <span>
              Shows the initial market cap at the
              <br />
              TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$100,000',
          description: (
            <span>
              Total funds aimed to be raised in
              <br />
              this token sale.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.10',
          description: (
            <span>
              Token price
              <br />
              during the Sale.
            </span>
          ),
        },
        {
          id: '$1k-$25k',
          name: 'Deposit Size',
          value: '$1-$25,000',
          description: (
            <span>
              Deposit range during the Pro-Rata
              <br />
              (fair-share) round
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for Token Sale participation.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: (
            <span>
              First unlock
              <br />2 hours after TGE
            </span>
          ),
          name: 'At TGE',
          description: (
            <span>
              The first token claim will be
              <br />
              available 2 hours after the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '10 months',
          name: 'Linear Vesting',
          description: (
            <span>
              After the first unlock, the remaining
              <br />
              tokens will be released linearly over
              <br />
              the following 10 months.
            </span>
          ),
        },
        {
          id: 'distribution-method',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              Tokens can be claimed via
              <br />
              the Magic Launchpad Dashboard.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '28-Days Post-TGE',
          name: 'Refund Policy',
          description: (
            <span>
              You can get a refund within 28 days
              <br />
              after the TGE if no tokens have
              <br />
              been claimed.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido-schedule',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sale-start',
          value: (
            <span>
              August 27th
              <br />
              11 AM UTC
            </span>
          ),
          name: 'Sale Start',
          description: <span>Start date of the Token Sale.</span>,
        },
        {
          id: 'sale-end',
          value: (
            <span>
              August 28th
              <br />3 PM UTC
            </span>
          ),
          name: 'Sale End',
          description: <span>End date of the Token Sale.</span>,
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: (
            <span>
              August 29th
              <br />2 PM UTC
            </span>
          ),
          description: (
            <span>
              Token exchange listing date and
              <br />
              time
            </span>
          ),
        },
        {
          id: 'token-distribution-start',
          name: 'Token Distribution Start',
          value: (
            <span>
              August 29th
              <br />4 PM UTC
            </span>
          ),
          description: (
            <span>
              Date and time for claiming your
              <br />
              first tokens.
            </span>
          ),
        },
      ],
    },
  ],
};
